import MuiDrawer, { type DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { Loader } from '../Loader/Loader';

type StyledDrawerProps = {
  isStackedDrawer?: boolean;
};

const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== 'isStackedDrawer',
})<StyledDrawerProps>`
  .MuiDrawer-paper {
    ${({ theme }) => theme.breakpoints.down(1920)} {
      width: ${({ isStackedDrawer }) => (isStackedDrawer ? '400px' : '800px')};
    }

    ${({ theme }) => theme.breakpoints.between(1920, 2560)} {
      width: ${({ isStackedDrawer }) => (isStackedDrawer ? '540px' : '1080px')};
    }

    ${({ theme }) => theme.breakpoints.up(2560)} {
      width: ${({ isStackedDrawer }) => (isStackedDrawer ? '640px' : '1280px')};
    }
  }
`;

type DrawerProps = Pick<MuiDrawerProps, 'onClose' | 'open' | 'sx'> & {
  children: ReactNode;
  'data-test'?: string;
  isError?: boolean;
  isLoading?: boolean;
  isStackedDrawer?: boolean;
};

export const Drawer = ({
  children,
  'data-test': dataTest,
  isError,
  isLoading,
  isStackedDrawer,
  onClose,
  open,
  sx,
}: DrawerProps) => {
  if (isError) {
    return <Navigate replace to="/error" />;
  }

  return (
    <StyledDrawer
      anchor="right"
      data-test={dataTest}
      isStackedDrawer={isStackedDrawer}
      open={open}
      onClose={onClose}
      sx={sx}
    >
      {isLoading ? <Loader /> : children}
    </StyledDrawer>
  );
};
